module.exports = __webpack_public_path__ + "newsletter/Components/PocketHitsSignup/images/logo.475f645f96642f84ea22dfb78a807ea0.svg";